import { useState } from 'react'
import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'
import { ScoopColumn, ScoopText } from '../../../../../../ui'
import styles from './FindingsSection.module.scss'

export const FindingsSection = ({ findings }) => {
    const [findingsExpanded, setFindingsExpanded] = useState(true)

    if (!findings || findings.length === 0) return null

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <ScoopText className={styles.title}>Key Findings ({findings.length})</ScoopText>
                <button
                    onClick={() => setFindingsExpanded(!findingsExpanded)}
                    className={styles.expandButton}
                    aria-label={findingsExpanded ? 'Collapse findings' : 'Expand findings'}
                >
                    {findingsExpanded ? <CaretUpIcon size={16} /> : <CaretDownIcon size={16} />}
                </button>
            </div>
            <div className={`${styles.collapse} ${findingsExpanded ? styles.expanded : ''}`}>
                <div className={styles.collapseInner}>
                    {findings.map((finding, i) => (
                        <ScoopColumn key={i} className={styles.findingItem}>
                            <ScoopText className={styles.findingText}>
                                • {finding.finding}
                            </ScoopText>
                            {finding.confidence !== undefined && (
                                <ScoopText className={styles.metadataText}>
                                    Confidence:{' '}
                                    {typeof finding.confidence === 'number'
                                        ? `${(finding.confidence * 100).toFixed(0)}%`
                                        : finding.confidence}
                                </ScoopText>
                            )}
                            {finding.businessImpact && (
                                <ScoopText className={styles.metadataText}>
                                    Impact: {finding.businessImpact}
                                </ScoopText>
                            )}
                            {finding.supportingEvidence?.length > 0 && (
                                <div className={styles.evidenceContainer}>
                                    <ScoopText className={styles.evidenceLabel}>
                                        Supporting evidence:
                                    </ScoopText>
                                    {finding.supportingEvidence.map((ev, j) => (
                                        <ScoopText key={j} className={styles.evidenceItem}>
                                            - {ev}
                                        </ScoopText>
                                    ))}
                                </div>
                            )}
                        </ScoopColumn>
                    ))}
                </div>
            </div>
        </div>
    )
}
